import ArrowLeftImage from '@/modules/Statistics/assets/icons/arrow-left.svg?react';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { TabItem } from '../../types/CustomTab.type';
import LineChart from '../charts/LineChart';
import CustomTabs from '../common/CustomTab';
import { useNavigate } from 'react-router-dom';
import { STATISTIC_LINKS } from '../../StatisticsLinks';
import { GetAdjusterRankChartQueryResponseType } from '../../queries/getAdjusterRankChart/getAdjusterRankChartQuery.type';

export default function RateChartSection({
  AdjusterChartData,
}: {
  AdjusterChartData: GetAdjusterRankChartQueryResponseType;
}) {
  const navigate = useNavigate();

  const labels = AdjusterChartData?.map((item) => item.month.name) ?? [];

  const nationalValues =
    AdjusterChartData?.map((item) => item.national_rank ?? 0) ?? [];

  const provinceValues =
    AdjusterChartData?.map((item) => item.province_rank ?? 0) ?? [];

  const tabs: TabItem[] = [
    {
      id: 'tab-1',
      label: 'کشوری',
      content: (
        <LineChart labels={labels} values={nationalValues} variant="country" />
      ),
    },
    {
      id: 'tab-2',
      label: 'استان',
      content: (
        <LineChart labels={labels} values={provinceValues} variant="branch" />
      ),
    },
  ];

  return (
    <Box margin="20px 0px" position="relative">
      <Flex
        flexDirection="row-reverse"
        justifyContent="space-between"
        alignItems="center"
        marginBottom="-40px"
        position="relative"
        pointerEvents="none"
      >
        <Flex
          alignItems="center"
          gap="4px"
          color="purple-primary"
          textStyle="b1"
          cursor="pointer"
          pointerEvents="auto"
          onClick={() => navigate(STATISTIC_LINKS.ranking)}
        >
          رتبه بندی
          <ArrowLeftImage />
        </Flex>
      </Flex>

      <CustomTabs
        items={tabs}
        defaultActiveId="tab-1"
        variant="compact"
        className={css({
          '& > div:first-child': {
            marginLeft: 'auto',
            marginRight: '0',
            backgroundColor: '#F5F5F5',
            padding: '4px',
            borderRadius: '10px',
          },
        })}
      />
    </Box>
  );
}
